import React from 'react'

import courseMappings from './course-mappings'

// Part of Layout component
const CourseMenu = (props) => {
  let course_menu_name_formatted = props.course.charAt(0).toUpperCase() + props.course.slice(1).toLowerCase()
  // Inserts key as string into template literal below
  // CourseMenuComponent gets key value from courseMappings.  The value is a react component

  let CourseMenuComponent = courseMappings[
    `${course_menu_name_formatted}CourseMenu`
  ]

  return (
    // Renders the React component that is stored in CourseMenuComponent variable
    <CourseMenuComponent
      location={props.location}
      authenticated={props.authenticated}
    />
  )
}

export default CourseMenu
